<template>
  <modal
    :is-opened="isOpened"
    :on-close="close"
    class="google-map__modal"
  >
    <template #header>
      <div class="google-map-modal__header google-map-modal-header">
        {{ trans('global.map') }}
      </div>
    </template>
    <template #body>
      <div class="google-map-modal__body">
        <div ref="gmap" class="google-map-modal__map" />
        <div class="google-map-modal__transport input-checkbox">
          <input
            v-model="showTransport"
            type="checkbox"
          >
          <label
            @click="toggleTransport"
          >
            {{ trans('offer.modal.map.show_transports') }}
          </label>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import { translationMixin } from '@tools/translation';
import { GoogleMapCustom } from '@organisms/google-map';

/**
 * Init Google map Modal Component
 */
export default {
  components: { Modal },
  mixins: [ translationMixin ],
  props: {
    isOpened: { type: Boolean, default: false },
  },
  data() {
    return {
      showTransport: true,
      map: null,
    };
  },

  watch: {
    /**
     * Trigger on modal opening,
     */
    isOpened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initGoogleMapModal();
        });
      }
    },
    /**
     * toggle transport network
     */
    showTransport() {
      this.map.toggleTransitNetwork();
    },
  },
  methods: {
    /**
     * close
     */
    close() {
      this.$emit('close');
    },
    /**
     * Init google map custom
     */
    initGoogleMapModal() {
      const options = {
        map: {
          zoomPosition: 'top-right',
          fullscreenControl: false,
        },
      };
      this.map = new GoogleMapCustom(this.$refs.gmap, options);
      this.map.renderFull();
    },
    /**
     * Toggle displayed transport network on the map
     */
    toggleTransport() {
      this.showTransport = !this.showTransport;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@styles/components/google-map-static';
</style>
